import script from "./productSummary.vue?vue&type=script&lang=ts&setup=true"
export * from "./productSummary.vue?vue&type=script&lang=ts&setup=true"

import "./productSummary.vue?vue&type=style&index=0&id=03953ca0&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03953ca0"]])

export default __exports__